const PackageIcon = ({ className, fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.24993 17.1613L2.24993 6.49998C2.24993 5.70418 2.8152 5.21595 3.26534 4.91828C3.71492 4.62098 4.35392 4.31832 5.07866 3.97507L8.19081 2.50065C9.75545 1.75848 10.8275 1.24998 11.9999 1.24998C13.1724 1.24998 14.2444 1.75848 15.8091 2.50065L18.9211 3.97503C19.6459 4.3183 20.2849 4.62096 20.7345 4.91828C21.1847 5.21595 21.7499 5.70418 21.7499 6.49998L21.7499 17.1613C21.7499 18.2817 20.9326 19.0268 19.9266 19.6305C18.9082 20.2416 17.1989 20.9637 15.3058 21.7633C13.8868 22.3632 12.972 22.75 11.9999 22.75C11.0279 22.75 10.1131 22.3632 8.69406 21.7633C6.80096 20.9636 5.09165 20.2416 4.07326 19.6305C3.06728 19.0268 2.24993 18.2817 2.24993 17.1613ZM5.32928 11.6645C5.51452 11.294 5.96502 11.1438 6.33551 11.329L8.33551 12.329C8.70599 12.5143 8.85616 12.9648 8.67092 13.3353C8.48567 13.7058 8.03517 13.8559 7.66469 13.6707L5.66469 12.6707C5.2942 12.4854 5.14403 12.0349 5.32928 11.6645ZM12 3.16014C11.3303 3.16014 10.6847 3.44123 8.84246 4.31397L5.99429 5.66325C5.18359 6.04731 4.6757 6.29062 4.35736 6.50105C4.6757 6.71148 5.18359 6.95479 5.99429 7.33885L7.06862 7.8478L14.7148 4.10491C13.2059 3.39566 12.613 3.16014 12 3.16014ZM16.9314 5.1543L9.28521 8.89718C10.7942 9.60644 11.387 9.84196 12 9.84196C12.6697 9.84196 13.3153 9.56087 15.1576 8.68813L18.0057 7.33885C18.8164 6.95479 19.3243 6.71148 19.6427 6.50105C19.3243 6.29062 18.8164 6.04731 18.0057 5.66325L16.9314 5.1543Z"
        fill={fill || "#888888"}
      />
    </svg>
  );
};

export default PackageIcon;
